import { render, staticRenderFns } from "./FormPFSI.vue?vue&type=template&id=7094b9e6&scoped=true"
import script from "./FormPFSI.vue?vue&type=script&lang=js"
export * from "./FormPFSI.vue?vue&type=script&lang=js"
import style0 from "./FormPFSI.vue?vue&type=style&index=0&id=7094b9e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7094b9e6",
  null
  
)

export default component.exports